import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import arrowIcon from "../../assets/images/icons/footer_bulletin_arrow_icn.png";

const ServiceFooter = () => {
  return (
    <div>
      <Row>
        <Col xs={12}>
          <h5 className="text-left footertitle footer_text_color">Services</h5>
          <Row className="footer_mob_pad">
            <Col xs={12} lg={12}>
             
              <div className="d-flex">
                 <div className="footer_icon">
                  <img src={arrowIcon} alt="Arrow Icon" />
                </div>
                <div className="text-left">
                  <div className="servicetextFooter footer_text_color mb-0">
                    <Link to="/agentforce">Agent Force </Link>
                  </div>
                </div>
              </div>

              <div className="d-flex">
               <div className="footer_icon">
                  <img src={arrowIcon} alt="Arrow Icon" />
                </div>
                <div className="text-left">
                  <div className="servicetextFooter footer_text_color mb-0">
                    <Link to="/automation">Automation</Link>
                  </div>
                </div>
              </div>
              <div className="d-flex">
                 <div className="footer_icon">
                  <img src={arrowIcon} alt="Arrow Icon" />
                </div>
                <div className="text-left">
                  <div className="servicetextFooter footer_text_color mb-0">
                    <Link to="/cloud-services">Advanced Cloud Services</Link>
                  </div>
                </div>
              </div>

              <div className="d-flex">
                <div className="footer_icon">
                  <img src={arrowIcon} alt="Arrow Icon" />
                </div>
                <div className="text-left">
                  <div className="servicetextFooter footer_text_color mb-0">
                    <Link to="/ai-data">AI & Data Engineering</Link>
                  </div>
                </div>
              </div>
              <div className="d-flex">
                 <div className="footer_icon">
                  <img src={arrowIcon} alt="Arrow Icon" />
                </div>
                <div className="text-left">
                  <div className="servicetextFooter footer_text_color mb-0">
                    <Link to="/dixap">Advanced DIXAP</Link>
                  </div>
                </div>
              </div>

              <div className="d-flex">
                <div className="footer_icon">
                  <img src={arrowIcon} alt="Arrow Icon" />
                </div>
                <div className="text-left">
                  <div className="servicetextFooter footer_text_color">
                    <Link to="/agentic#services_section">Agentic AI</Link>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ServiceFooter;
